import axiosInternal from '@/libs/axios-internal'

export default {
  // CRUD básico
  async criarAgendamento(dados) {
    try {
      const response = await axiosInternal.post('/agendamentos', dados)
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  async listarAgendamentos(params = {}) {
    try {
      const response = await axiosInternal.get('/agendamentos', { params })
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  async buscarAgendamento(id) {
    try {
      const response = await axiosInternal.get(`/agendamentos/${id}`)
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  async atualizarAgendamento(id, dados) {
    try {
      const response = await axiosInternal.put(`/agendamentos/${id}`, dados)
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  async excluirAgendamento(id, motivoCancelamento = null) {
    try {
      const payload = motivoCancelamento ? { motivo_cancelamento: motivoCancelamento } : {}
      const response = await axiosInternal.delete(`/agendamentos/${id}`, { data: payload })
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  // Endpoints especializados
  async buscarAgendamentosCalendario(params = {}) {
    try {
      const response = await axiosInternal.get('/agendamentos/calendario', { params })
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  async buscarMeusAgendamentos(params = {}) {
    try {
      const response = await axiosInternal.get('/agendamentos/atendentes/me', { params })
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  async buscarAgendamentosPorAtendente(atendenteId, params = {}) {
    try {
      const response = await axiosInternal.get(`/agendamentos/atendentes/${atendenteId}`, { params })
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  async atualizarStatusAgendamento(id, status, motivo = null, observacoes = null) {
    try {
      const payload = { status }
      if (motivo) payload.motivo = motivo
      if (observacoes) payload.observacoes = observacoes

      const response = await axiosInternal.patch(`/agendamentos/${id}/status`, payload)
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  async reagendarAgendamento(id, dados) {
    try {
      // Nova rota interna para reagendar: PUT /internal/v1/agendamentos/{id}
      const response = await axiosInternal.put(`/agendamentos/${id}`, dados)
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  async buscarHistoricoAgendamento(id) {
    try {
      const response = await axiosInternal.get(`/agendamentos/${id}/historico`)
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  async buscarEstatisticasAgendamentos(params = {}) {
    try {
      const response = await axiosInternal.get('/agendamentos/estatisticas', { params })
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  async buscarAtividadesRecentes(params = {}) {
    try {
      const response = await axiosInternal.get('/agendamentos/recentes', { params })
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  async buscarProximosAgendamentos(params = {}) {
    try {
      const response = await axiosInternal.get('/agendamentos/proximos', { params })
      return response.data
    } catch (error) {
      throw this.tratarErro(error)
    }
  },

  // Tratamento de erros
  tratarErro(error) {
    if (error.response) {
      const { status, data } = error.response

      let mensagem = 'Erro ao processar solicitação'

      switch (status) {
        case 400:
          mensagem = data.message || 'Dados inválidos'
          break
        case 401:
          mensagem = 'Não autorizado'
          break
        case 403:
          mensagem = 'Acesso negado'
          break
        case 404:
          mensagem = 'Agendamento não encontrado'
          break
        case 422:
          mensagem = data.message || 'Erro de validação'
          break
        case 500:
          mensagem = 'Erro interno do servidor'
          break
        default:
          mensagem = data.message || mensagem
      }

      const erroTratado = new Error(mensagem)
      erroTratado.status = status
      erroTratado.dados = data

      return erroTratado
    }

    return new Error('Erro de conexão')
  },
}
